import { render, staticRenderFns } from "./regisInfoInside.vue?vue&type=template&id=0f0dad29"
import script from "./regisInfoInside.vue?vue&type=script&lang=js"
export * from "./regisInfoInside.vue?vue&type=script&lang=js"
import style0 from "./regisInfoInside.vue?vue&type=style&index=0&id=0f0dad29&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports